export const INVESTING_IDEAS_PAGE_SIZE = 48;
